import { IconCheck, IconMail } from "@tabler/icons-react";
import React, { useRef, useState } from "react";
import { sendRegistrationContinuationEmail } from "sources/account";

export default function RegistrationContinuationEmail({ email }: { email: string }) {
    const [sending, setSending] = useState(false);
    const [sent, setSent] = useState(false);
    const requestRunning = useRef(false);

    const sendEmail = async () => {
        if (requestRunning.current || sent) {
            return;
        }

        requestRunning.current = true;
        setSending(true);

        try {
            const response = await sendRegistrationContinuationEmail();
            if (response) {
                setSent(true);
            }
        } catch {
            return;
        } finally {
            requestRunning.current = false;
            setSending(false);
        }
    };

    return (
        <div className="mb-3">
            <div className="r-relay-help__text text-break" role="status" aria-live="polite">
                {sent ? (
                    <>
                        Письмо отправлено на <strong>{email}</strong>. Откройте его на компьютере, чтобы войти и
                        продолжить регистрацию.
                    </>
                ) : (
                    <>
                        Отправим на <strong>{email}</strong> письмо со ссылкой для входа и продолжения регистрации.
                    </>
                )}
            </div>
            <button
                className="r-relay-help__support-button"
                type="button"
                disabled={sending || sent}
                onClick={sendEmail}
            >
                {sent ? <IconCheck /> : <IconMail />}
                <span>{sending ? "Отправляем письмо…" : sent ? "Письмо отправлено" : "Отправить письмо на почту"}</span>
            </button>
        </div>
    );
}
